module.exports = __webpack_public_path__ + "img/number-1.26c7cf82.svg";